import { postApiGalaxyServer } from 'services';

export interface BulkToggleMfaResetPayload {
  emails: string[];
}

export interface BulkToggleMfaResetSuccessResponse {
  status: string;
}

export const bulkToggleMfaReset = ({
  params: data,
  token,
  config = {},
}: BaseApiParams<BulkToggleMfaResetPayload>) =>
  postApiGalaxyServer(`/rails_api/account/toggle-mfa-reset`, data, config, token);
